import { createSelector } from 'reselect'
import { uniqBy } from 'lodash'

const hasName = ({ name }) => name
const toLowerCase = ({ name }) => {
  return name?.toLowerCase()
}
const getFormattedValue = (key, value) => {
  return uniqBy(value.filter(hasName), toLowerCase)
}

const getExpenseFilters = ({ ledgerFilter }) => ledgerFilter.filters
const getFetchingExpenseFilters = ({ ledgerFilter }) => ledgerFilter.fetching

export const filterSelectors = {
  getExpenseFilters: createSelector([getExpenseFilters], (expenseFilters) => {
    return Object.entries(expenseFilters).reduce((acc, [key, value]) => {
      return {
        ...acc,
        [key === 'docTypes' ? 'documentTypes' : key]: getFormattedValue(key, value),
      }
    }, {})
  }),
  getFetchingExpenseFilters: createSelector(
    [getFetchingExpenseFilters],
    (fetchingExpenseFilters) => fetchingExpenseFilters,
  ),
}
